import { IonAlert } from '@ionic/react'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AlertConstants } from './store/alert.constants'
import { getAlertSelector } from './selectors'
import './Alert.component.css'

export const AlertComponent: React.FC = () => {
  const alert = useSelector(getAlertSelector)
  const dispatch = useDispatch()
  const { subHeader, header, message, buttons, showAlert, showEqualWidthButton } = alert

  return (
    <IonAlert
      id='alert'
      isOpen={!!showAlert}
      backdropDismiss={false}
      onDidDismiss={() => dispatch({ type: AlertConstants.RESET_SHOW_ALERT })}
      header={header}
      subHeader={subHeader}
      message={message}
      buttons={buttons}
      cssClass={showEqualWidthButton ? 'custom-alert-equal-button' : 'custom-alert'}
    />
  )
}
